import request from '@app/utils/apiRequest';

export const requestLogin = (data) =>
    request.post(`user/login`, data);

export const requestResetPassword = (data) =>
    request.post(`user/reset-password`, data);

export const requestChangePassword = (data) =>
    request.post(`user/change-password`, data);

export const requestAccessHistories = (params) => request.get(`user/accesslog-history`, { params: params });

export const requestSaveUser = (data) => request.post(`user/save`, data);
export const requestSaveEndPriDate = (data) => request.post(`user/update-end-pri-date`, data);

export const requestGetUserList = (params) => request.get(`user/list`, { params: params });
export const requestGetUserEmailList = (params) => request.get(`user/email/list`, { params: params });
export const requestSaveUserEmail = (data) =>
    request.post(`user/email/save`, data);

export const requestGetNotifications = (params) => request.get(`user/notifications`, { params: params });

export const requestApproveNotify = (data) =>
    request.post(`user/notifications/approve`, data);

export const requestRejectNotify = (data) =>
    request.post(`user/notifications/reject`, data);

export const requestReportWrongInput = (data) =>
    request.post(`user/notifications/report-wrong-input`, data);

export const requestRemoveInputOfOtherUser = (data) =>
    request.post(`user/remove-input-of-other-user`, data);

export const requestPriorityInputUsers = (params) => request.get(`user/priority-input-users`, { params: params });

export const requestSubmitPriorityInputNotes = (data) => request.post(`user/submit-priority-input-notes`, data);

export const requestAdminResetPasswordUser = (data) => request.post(`user/admin-reset-password-user`, data);
